
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndBrand/create",
      function () {
        return require("private-next-pages/remyndBrand/create.tsx");
      }
    ]);
  